const CrossRed = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="m11.999 13.415 6.643 6.643 1.414-1.414-6.643-6.643 6.644-6.643-1.415-1.415L12 10.587 5.356 3.943 3.94 5.358 10.585 12l-6.643 6.643 1.414 1.414 6.643-6.643z" fill="#D32F2F" />
    </svg>
)

export default CrossRed;